/**
 * Datapoint configurations for regional quick settings
 */
export default {
    CurrentTimeZoneQuick: {
        datapoint: {
            name: 'CurrentTimeZoneQuick',
            customData: function (currentTimeZone) { return ({
                currentTimeZone: currentTimeZone,
            }); },
        },
    },
    DateFormatQuick: {
        datapoint: {
            name: 'DateFormatQuick',
            customData: function (dateFormat) { return ({
                dateFormat: dateFormat,
            }); },
        },
    },
    TimeFormatQuick: {
        datapoint: {
            name: 'TimeFormatQuick',
            customData: function (timeFormat) { return ({
                timeFormat: timeFormat,
            }); },
        },
    },
};
//# sourceMappingURL=datapoints.js.map